import { useEffect, useRef, useState } from 'react'
import { Pressable, Text, TextInput, View } from 'react-native'
import { ArrowLeft, ArrowClockwise } from 'phosphor-react-native'
import { Theme } from '@monorepo/relayably/theme'

import { submitAuth } from '../../auth/authSlice'
import { useAppDispatch } from '../../store'
import { createPaneStyles } from './shared'

export const OtpPane = ({
  fullName,
  intent,
  onBack,
  phoneNumber,
  theme,
}: {
  fullName: string
  intent: 'sign-in' | 'sign-up'
  onBack: () => void
  phoneNumber: string
  theme: Theme
}) => {
  const styles = createPaneStyles(theme)
  const dispatch = useAppDispatch()
  const [otp, setOtp] = useState(['', '', '', '', '', ''])
  const [timer, setTimer] = useState(30)
  const refs = useRef<Array<TextInput | null>>([])

  useEffect(() => {
    const interval = setInterval(() => setTimer(current => (current > 0 ? current - 1 : 0)), 1000)
    return () => clearInterval(interval)
  }, [])

  const updateDigit = (index: number, value: string) => {
    const digit = value.replace(/\D/g, '').slice(-1)
    const next = [...otp]
    next[index] = digit
    setOtp(next)

    if (digit && index < next.length - 1) {
      refs.current[index + 1]?.focus()
    }
  }

  return (
    <View style={styles.pane}>
      <View style={styles.codeRow}>
        {otp.map((digit, index) => (
          <TextInput
            key={index}
            keyboardType='number-pad'
            maxLength={1}
            onChangeText={value => updateDigit(index, value)}
            ref={input => {
              refs.current[index] = input
            }}
            style={styles.codeInput}
            value={digit}
          />
        ))}
      </View>

      <View style={styles.form}>
        <Pressable
          onPress={() =>
            void dispatch(
              submitAuth({
                mode: intent,
                method: 'phone',
                email: '',
                password: '',
                fullName,
                phoneNumber,
                otp: otp.join(''),
              })
            )
          }
          style={styles.submitButton}
        >
          <Text style={styles.submitButtonText}>Verify Code</Text>
        </Pressable>

        <View style={styles.navRow}>
          <Pressable onPress={onBack} style={styles.navButton}>
            <ArrowLeft color={theme.colors.text} size={16} />
            <Text style={styles.navButtonText}>Back</Text>
          </Pressable>

          <View style={styles.navButton}>
            <ArrowClockwise color={timer > 0 ? theme.colors.inactive : theme.colors.text} size={16} />
            <Text style={[styles.navButtonText, { color: timer > 0 ? theme.colors.inactive : theme.colors.text }]}>
              {timer > 0 ? `Resend in ${timer}s` : 'Resend Code'}
            </Text>
          </View>
        </View>
      </View>

      <Text style={styles.securityHint}>Never share this code with anyone.</Text>
    </View>
  )
}
